<!-- 添加选项 -->
<template>
  <div class="addSelectTemplate">
    <div
      class="addSelect"
      v-for="(item, index) in selectList"
      :key="index"
      @click="selectListActiveFn(item, index)"
      :class="{ selectActive: selectListActive[index] }"
    >
      <div class="addSelectList">
        <div class="addSelectBox">
          <div
            class="selctHead"
            @blur="editSelectName(item, $event)"
            contenteditable="true"
            @keydown="handleKeyDown"
          >
            {{ item.selectName }}
          </div>

          <el-upload
            :action="uploadUrlVue"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="item.fileList"
            :on-change="handleChange"
            class="elUpload"
            accept="image/png, image/jpeg"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :headers="customHeaders"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file, index)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>

          <input
            type="text"
            class="inputSelect"
            v-model="item.value"
            placeholder="请输入内容"
            v-if="!item.isImg"
          />
        </div>
      </div>

      <div class="addSelectBtn">
        <img
          class="addSelect"
          src="../../../assets/images/icon-addSelect.png"
          @click="copyAddSelect(item)"
        />
        <img
          class="removeSelect"
          src="../../../assets/images/icon-close.png"
          @click="removeSelect(item)"
        />
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadUrl } from "@/constants/constants";
import { getToken } from '@/utils/auth';
// import { Alert } from 'element-ui';
 import _ from "lodash";
const TAG = "[AddSelect.vue] ";

export default {
  name: "AddSelect",
  data() {
    return {
      customHeaders:{
          'Authorization':getToken()
      },
      selectList: [], // 选项 [{ id: 1, selectName: "A", value: "", isImg: false, fileList: [] }]
      selectListActive: [], // 选项选中状态开关
      dialogImageUrl: "", // 图片放大路径
      dialogVisible: false, // 图片放大开关
      disabled: false,
      nowItem: undefined,
      uploadUrlVue: uploadUrl, // 上传图片地址
      optionLetter:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    };
  },

  props: ["id", "selectListCopy"],

  mounted() {
    this.selectList = this.selectListCopy;

    if (this.selectList.length == 0) {
      this.selectList = [
        { id: 1, selectName: "A", value: "", isImg: false, fileList: [] },
      ];
    }
  },

  methods: {
    // 禁止换行
    handleKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    // 复制添加选项
    copyAddSelect(item) {
      let id =
        parseInt(new Date().getTime()) + "" + parseInt(Math.random() * 10000);

      let index = this.selectList.findIndex((items) => Object.is(item, items));
      
      let model = _.cloneDeep(this.selectList);
      model.splice(index + 1, 0, {
        id,
        selectName: this.optionLetter[index + 1],
        value: "",
        isImg: false,
        fileList: [],
      });
      for(let i=0;i<model.length;i++){
        model[i].selectName = i<26?this.optionLetter[i]:'Z'; // 修改数组元素
      }
      this.selectList = [];
      this.$nextTick(()=>{
        this.selectList = JSON.parse(JSON.stringify(model))
      })
      // this.selectList = _.cloneDeep(model);

      // this.selectList.splice(index + 1, 0, {
      //   id,
      //   selectName: this.optionLetter[index + 1],
      //   value: "",
      //   isImg: false,
      //   fileList: [],
      // });
      // for(let i=0;i<this.selectList.length;i++){
      //   type = i<26?this.optionLetter[i]:'Z'; // 修改数组元素
      //   if(this.selectList[i].selectName!=type){
      //     module=JSON.parse(JSON.stringify(this.selectList[i]));
      //     module.selectName = type;
      //     this.selectList.splice(i, 1, module);
      //   }
      // }
      // let newData = _.cloneDeep(this.selectList);
      // this.selectList = [];
      // this.$nextTick(()=>{
      //   this.selectList = JSON.parse(JSON.stringify(newData))
      // })
      // for(let i=0;i<this.selectList.length;i++){
      //   console.log(this.selectList[i])
      //   this.selectList[i].selectName = i<26?this.optionLetter[i]:'Z'; // 修改数组元素
      // };
      // this.selectList.push(0,1,JSON.parse(JSON.stringify(this.selectList[0])))
    },

    // 移除选项
    removeSelect(item) {
      let index = this.selectList.findIndex((items) => Object.is(item, items));

      this.selectList.splice(index, 1);
    },

    // 编辑选项名称
    editSelectName(item, e) {
      let innerHTML = e.target.innerHTML;

      item.selectName = innerHTML;
    },

    // 移除图片
    handleRemove(file, index) {
      console.log("handleRemove", file, this.selectList[index].fileList);

      this.selectList[index].fileList.some((item, index1) => {
        console.log("item.uid ", item.uid, file.uid);
        if (item.uid == file.uid) {
          this.selectList[index].fileList.splice(index1, 1);

          let isB = Boolean(this.selectList[index].fileList.length);
          if (!isB) {
            setTimeout(() => {
              this.selectList[index].isImg = isB;
            }, 1000);
          }
          console.log(
            "this.selectList[index].isImg",
            this.selectList[index].isImg
          );
          return true;
        }
      });
      console.log(TAG, this.selectList, "handleChange");
    },

    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 图片新增
    handleChange(file, fileListArr) {
      console.log(TAG, JSON.stringify(file), "handleChange", fileListArr);

      if (file["status"] != "success") return;

      for (let i = 0; i < fileListArr.length; i++) {
        if (fileListArr[i]["status"] == "success") {
          // if (fileListArr[i].hasOwnProperty("response")) {
          if (
            Object.prototype.hasOwnProperty.call(fileListArr[i], "response")
          ) {
            if (fileListArr[i]["response"]["code"] == 0) {
              fileListArr[i].url = fileListArr[i]["response"]["data"];
            }
          }
        }
      }

      this.nowItem.fileList = fileListArr;
      this.nowItem.isImg = Boolean(this.nowItem.fileList.length);

      console.log(TAG, this.selectList, "handleChange", fileListArr);
    },

    // 点击选项
    selectListActiveFn(e, index) {
      console.log("e", e);
      this.nowItem = e;

      this.selectListActive = [];
      this.selectListActive[index] = true;
    },

    // 图片上传成功
    uploadSuccess(response, file) {
      console.log(TAG, "uploadSuccess", response, file, this.fileList);
      if (response["code"] == 0) {
        this.$message({
          message: "图片上传成功！",
          type: "success",
        });
      } else {
        this.$message.error("图片上传失败！");
      }
    },

    // 图片上传失败
    uploadError() {
      console.log(TAG, "uploadError");
      this.$message.error("图片上传失败！");
    },
  },

  watch: {
    selectList: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        this.$emit("selectListChange", newValue, this.id);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.addSelectTemplate {
  padding: 5rem 0 9rem;
}

.addSelect.selectActive {
  .addSelectBox {
    border: 1rem solid #0bae6a;
  }

  .removeSelect {
    display: block;
  }
}

.addSelect {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5rem 0;

  .addSelectList {
    width: 80%;
    margin-left: 16rem;
  }
  .addSelectBox {
    height: 32rem;
    border: 1rem solid #e9e9e9;
    border-radius: 20rem;
    display: flex;
    flex-direction: row;
    align-content: center;
    overflow: hidden;

    .selctHead {
      width: 38rem;
      text-align: center;
      line-height: 32rem;
      // background: #b0dedf;
      background: linear-gradient(to right, #0bae5b, #08c162);
      color: #fff;
      font-size: 14rem;
      padding-left: 4rem;
    }
    .selctHead:focus-visible {
      outline: 0;
    }
  }
}
.inputSelect {
  padding: 0 6rem;
  border: 0;
  width: calc(100% - 90rem);
}
.inputSelect:focus-visible {
  outline: none;
}

.addSelectBtn {
  position: relative;
  .addSelect {
    width: 14rem;
    height: 14rem;
    margin-left: 10rem;
    cursor: pointer;
  }

  .removeSelect {
    position: absolute;
    width: 14rem;
    height: 14rem;
    left: -14rem;
    top: -12rem;
    cursor: pointer;
    transform: rotate(0deg);
    transition: all 0.2s;
    display: none;
  }
  .removeSelect:hover {
    transform: rotate(90deg);
  }
}

.addSelectList {
  :deep .el-upload-list--picture-card .el-upload-list__item-actions {
    font-size: 12rem;
    background-color: rgba(0, 0, 0, 0.2);
  }
  :deep
    .el-upload-list--picture-card
    .el-upload-list__item-actions
    .el-upload-list__item-delete {
    position: absolute;
    right: -8rem;
    top: -5rem;
    background: url("../../../assets/images/icon-close.png") no-repeat;
    background-size: 10rem 10rem;
    background-position: center;
    width: 10rem;
    height: 10rem;
    margin: 0;

    > i {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.addSelectBox {
  position: relative;
  .el-upload--picture-card {
    width: 32rem;
    height: 32rem;
    position: absolute;
    right: 5rem;
    top: 0;

    background: url("../../../assets//images/icon-addImg.png") no-repeat;
    background-position: center;
    background-size: 14rem 14rem;
    border: none;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    border-radius: 3rem;
    width: 24rem;
    height: 24rem;
    margin: 4rem 2rem 0 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    float: left;
    overflow: initial;

    > div {
      display: flex;
      justify-content: center;
    }
  }
}
</style>

